import { observer } from 'mobx-react';
import React, { forwardRef, useMemo } from 'react';

import { SIDE_DRAW_MODAL_TYPE } from '../../../../const/modalType';
import { useStores } from '../../../../hooks';
import { CloseButtonModal } from '../../../CloseButton';

import styles from './styles/dawer_modal.module.scss';

const SideDrawModal = observer(
  forwardRef(({ children }, ref) => {
    const { modalStore } = useStores();
    const { close, modalsProps, currentModal } = modalStore;

    const { modalType = SIDE_DRAW_MODAL_TYPE.BASE } =
      modalsProps?.[currentModal] || {};

    return (
      <div className={styles.side_draw}>
        <div className={styles[`side_draw__image--${modalType}`]} />
        <div ref={ref} className={styles.side_draw_content}>
          <CloseButtonModal handleClose={close} />
          {children}
        </div>
      </div>
    );
  }),
);

export default SideDrawModal;
